export class DatabricksIntegrationConfig {
    'serverHostname';
    'oauth2ClientId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serverHostname",
            "baseName": "serverHostname",
            "type": "string",
            "format": ""
        },
        {
            "name": "oauth2ClientId",
            "baseName": "oauth2ClientId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DatabricksIntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
